/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {BehaviorSubject} from 'rxjs';
import { Injectable, EventEmitter} from '@angular/core';
import { SystemType } from '../model/enums/system.type';

@Injectable()
export class ModeService {

  currentMode: SystemType;
  mode = new BehaviorSubject<SystemType>(SystemType.BV);
  mode$ = this.mode.asObservable();

  constructor(){
    if (localStorage.hasOwnProperty('R-CRM-SYSTEM_MODE')) {
      this.currentMode = SystemType[<string>localStorage.getItem('R-CRM-SYSTEM_MODE')];
      this.mode.next(this.currentMode);
    }
  }
}
